export default __webpack_public_path__ + "static/media/zweytickL.a779f80e.jpg";